// extracted by mini-css-extract-plugin
export default {"otpInput":"OtpInputs_otpInput__YgoSW","otpValidate":"OtpInputs_otpValidate__esAue"};